import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ISite } from '../../../shared/models';
import { ActionReducer } from '@ngrx/store/src/models';
import { Action, createReducer, on } from '@ngrx/store';
import { SITES_ACTIONS } from '../actions/sites.actions';

export const SITES_STATE_KEY = 'sites';

export interface ISitesState extends EntityState<ISite> {
  loading: boolean;
  error: Error | null;
}

export const sitesAdapter: EntityAdapter<ISite> = createEntityAdapter<ISite>({
  sortComparer: (site1, site2) => site1.name.localeCompare(site2.name),
});

export const initialState: ISitesState = sitesAdapter.getInitialState({
  loading: false,
  error: null,
});

const _sitesReducer: ActionReducer<ISitesState> = createReducer<ISitesState>(
  initialState,
  on(SITES_ACTIONS.getAllSites, (state) => ({ ...state, loading: true })),
  on(SITES_ACTIONS.getSitesSuccess, (state, { payload }) => sitesAdapter.setAll(payload, { ...state, loading: false })),
  on(SITES_ACTIONS.getSitesError, (state, { payload }) => ({ ...state, loading: false, error: payload })),
);

export const sitesReducer = (state: ISitesState | undefined, action: Action): ISitesState =>
  _sitesReducer(state, action);
